module.exports = __webpack_public_path__ + "img/02_DSC7510.dfcba90b.jpg";